import React from "react";
import PropTypes from "prop-types";
import NavIcon from "./NavIcon";
import styles from "./NavIcons.module.css";
import { getNavPartProps } from "../navigationBarBrandRefreshClasses";

const cartIcon = require("./imgs/Cart.svg");

const CartIcon = ({ cartQuantity, toggleCartMenu, onClick }) => {
  if (!cartQuantity) {
    return null;
  }

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    toggleCartMenu();
  };

  return (
    <NavIcon
      onClick={handleClick}
      ariaLabel={`Cart with ${cartQuantity} items`}
    >
      <div className={styles.cartIconWrapper}>
        <img
          src={cartIcon}
          alt=""
          className={styles.cartIcon}
          data-part={getNavPartProps("cart-icon")}
        />
        <span
          className={styles.cartBadge}
          data-part={getNavPartProps("cart-badge")}
        >
          {cartQuantity > 99 ? "99+" : cartQuantity}
        </span>
      </div>
    </NavIcon>
  );
};

CartIcon.propTypes = {
  cartQuantity: PropTypes.number,
  toggleCartMenu: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

CartIcon.defaultProps = {
  cartQuantity: 0,
  onClick: null,
};

export default CartIcon;
